import React from 'react'
import { Link } from 'react-router-dom'
import SEO from './SEO'
import './../styles/About.css'

const Community = () => (
  <>
    <SEO
      path="/community"
      title="Community"
      description="QA Tech's community — talks, meet-ups and conversations with engineers, testers and designers across the UK tech scene."
      keywords="QA Tech community, software testing community, QA meetups, UK tech community, QA networking"
    />
    <div className="body about-page">
      <header className="about-hero">
        <span className="eyebrow">Community</span>
        <h1>People we learn from. People we share with.</h1>
        <p>
          We&rsquo;re part of a wider community of engineers, testers and
          designers across the UK and beyond. From local meet-ups to online
          conversations, this is where we share what we&rsquo;re learning.
        </p>
      </header>

      <section className="about-section about-cta">
        <h2>Want to collaborate?</h2>
        <p>
          We&rsquo;re always up for a chat about software quality, modern
          engineering or marketing. <Link to="/contact">Drop us a line</Link>.
        </p>
      </section>
    </div>
  </>
)

export default Community
